import { HttpParams } from "@angular/common/http";
import * as moment from 'moment';

export class LiftRideCriteria {
  dateFrom: Date;
  dateTo: Date;
  floor: number = null;
  liftId: number;
  statisticsDatetimeType = 'day';

  constructor() {
    let today = moment();
    this.dateTo = today.toDate();
    this.dateFrom = today.subtract(7, "days").toDate();
  }

  paramsExport(): HttpParams {
    let params = new HttpParams()
      .set('statisticsDatetimeType', this.statisticsDatetimeType)
      .set('dateFrom', moment(this.dateFrom).format('MM/DD/YYYY'))
      .set('dateTo', moment(this.dateTo).format('YYYY/MM/DD')+'T23:59:59')
      .set('liftId', String(this.liftId));

    return params;
  }
}
